var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",attrs:{"id":"wrapper"}},[_c('nprogress-container'),_c('Header'),_c('Sidebar'),_c('div',{staticClass:"main_content",attrs:{"id":"container"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }